// import Cryptr from 'cryptr';
import errorHandler from "@/services/handler/erroHandler";
import axiosInstance from "@/services/manager/manager.service";



export const onCallService = {
    get
};
/*let crypt = new Cryptr(process.env.VUE_APP_REMEMBER_CRYPT);*/

async function get(){
    try {
        let rets = await axiosInstance.get(`/oncalls`);
        if (rets) {
            let now = new Date();
            return rets.data.filter(onCall => new Date(onCall.begin) < now && new Date(onCall.end) > now);
        }
        return 400;
    } catch (error) {
        return errorHandler(error);
    }
}



